import React from "react";
import { Label } from "semantic-ui-react";

export function StatusMark(props: { status: number | null, sortName?: boolean }) {
    const { status, sortName } = props;
    if (status === 1) {
        return <Label color="olive" size="mini" circular>{sortName ? 'P' : 'Pass'}</Label>
    } else if (status === 2) {
        return <Label color="orange" size="mini" circular>{sortName ? 'F' : 'Fail'}</Label>
    } else if (status === 3) {
        return <Label color="red" size="mini" circular>{sortName ? 'I' : 'Invalid'}</Label>
    } else if (status === 4) {
        return <Label color="black" size="mini" circular>{sortName ? 'S' : 'Stopped'}</Label>
    }  else {
        return <Label color="grey" size="mini" circular>{sortName ? 'U' : 'Skip'}</Label>
    }
}

export function FileStatusMark(props: { status: number | null, sortName?: boolean }) {
    const { status, sortName } = props;
    if (status === 1) {
        return <Label color="olive" size="mini" circular>{sortName ? 'P' : 'Pass'}</Label>
    } else if (status === 2) {
        return <Label color="orange" size="mini" circular>{sortName ? 'W' : 'Fail'}</Label>
    } else if (status === 3) {
        return <Label color="red" size="mini" circular>{sortName ? 'F' : 'Invalid'}</Label>
    } else if (status === 4) {
        return <Label color="black" size="mini" circular>{sortName ? 'S' : 'Stopped'}</Label>
    } else {
        return <Label color="grey" size="mini" circular>{sortName ? 'U' : 'Unknown'}</Label>
    }
}